import { ROLE_TYPES } from 'utils/permissions';

export const PROJECT_CATEGORIES = ['commercial', 'supermachine', 'internal'];

export const DE_PERMISSIONS = {
  filters: [ROLE_TYPES.ceo, ROLE_TYPES.finance_specialist],
};
